export class GroupTransformer {
  static transform(obj) {
    let group = {};
    group.id = obj.id;
    group.name = obj.attributes.name;
    return group;
  }
}



// WEBPACK FOOTER //
// ./src/helpers/groups/group.transformer.js